import BaseRoutes from "./data/BaseRoutes";
import AuthRoutes from "./data/AuthRoutes";

export default [...BaseRoutes, ...AuthRoutes];
